// extracted by mini-css-extract-plugin
export var cardContainer = "_pl-0";
export var cardHeader = "_pl-2";
export var collapsedState = "_pl-3";
export var dragHandle = "_pl-5";
export var dragHandleIcon = "_pl-6";
export var dragging = "_pl-1";
export var titleArea = "_pl-4";